export enum CoreStorageEnum {
    currency = 'pin_currency',
    tokenName = 'access_token',
    tokenType = 'token_type',
    tokenLastCheck = 'token_lastcheck',
    clientId = 'clientId',
    username = 'username',
    testId = 'testId',
}
